import { RouteName } from './types';

/** Pages opened from an e-mail link, signed out: no menu, and nothing that needs a session. */
const PUBLIC_ROUTES = [RouteName.SurveyAnswer, RouteName.CommentThread];

/**
 * Matched as the host matches them, so both agree on what is public: case-insensitive, and on a whole
 * segment, so that `/performance-management/comment-threads` is not taken for the thread page.
 */
export const isPublicRoute = (pathname: string) => {
    const path = pathname.toLowerCase();

    return PUBLIC_ROUTES.some((route) => {
        const prefix = route.toLowerCase();
        return path === prefix || path.startsWith(`${prefix}/`);
    });
};
